import React from 'react';
import { Routes } from 'react-router';
import { Route } from 'react-router-dom';
import GeneralReport from './pages/GeneralReport';
import MerchantsReport from './pages/MerchantsReport';
import DetailMerchantReport from './pages/MerchantsReport/DetailMerchentReport';
import ExpediteDeliveriesReport from './pages/ExpediteDeliveriesReport';
import OrdersReport from './pages/OrdersReport';
import PayoutsReport from './pages/PayoutsReport';
import ReportTypes from './pages/ReportTypes';

function Reports() {
  return (
    <Routes>
      <Route path="/" element={<ReportTypes />} />
      <Route path="general" element={<GeneralReport />} />
      <Route path="merchants" element={<MerchantsReport />} />
      <Route path="merchants/:merchantId" element={<DetailMerchantReport />} />
      <Route path="orders" element={<OrdersReport />} />
      <Route path="expedite-deliveries" element={<ExpediteDeliveriesReport />} />
      <Route path="payouts" element={<PayoutsReport />} />
    </Routes>
  );
}

export default Reports;
